import {showForms} from './all';

const pid = parseInt($('#Project_Pid').val());

export default function () {
    let $mprAgenda = $('#mprAgendaForm');

    if ($mprAgenda.length) {
        if (parseInt($('#Id').val()) > 0) {
            showForms();
        }

        //Attach Events
        createAgendaEvent();
        changeAgendaEvent();
        saveAgendaEvent();
    }
}

// Events
// =========================================================================
const createAgendaEvent = function () {
    let $createNewAgendaBtn = $('#mprAgendaCreateNewBtn');
    if ($createNewAgendaBtn.length) {
        $createNewAgendaBtn.click(function () {
            //get mid (monthly id from header record)
            let data = {
                pid: pid,
                month: new Date($('#mprAgendaExistingList').data('kendoDropDownList').text().split(' - ')[0].replace(' ', ' 1 ')).toLocaleDateString().replace('/1/', '/')
            };

            // Post to create new MPR Agenda
            $.post('/Forms/ProjectReview/CreateMprAgendaHeader', data, function (response) {
                let info = response.split(':'), mid = parseInt(info[0]);

                $('#Id').val(mid);
                $('#mprAgendaForm').submit();
            });
        });
    }
};

const changeAgendaEvent = function () {
    let $agendaSelect = $('#mprAgendaExistingList');
    if ($agendaSelect.length) {
        $agendaSelect.change(function () {
            $('#Id').val(parseInt(this.value));
            $('#mprAgendaForm').submit();
        });
    }
};

const saveAgendaEvent = function () {
    let $saveAgendaBtn = $('.form-footer__content button');
    if ($saveAgendaBtn.length) {
        $saveAgendaBtn.click(function () {
            event != null && event.preventDefault();
            let saveSuccess = 1, finalized = $('#finalizeForm').prop('checked');
            //Set Finalized Attribute
            $('#Finalized').val(finalized);
            let url = '/Forms/ProjectReview/SaveMPRAgendaAnswers?pid=' + pid;
            let formData = $('#mprAgendaForm').serializeArray();
            $.post(url, formData, function (response) {
                response = response.split(':')[0];
                if (response !== 'Success') {
                    saveSuccess = 0;
                    if (response === 'Finalized') {
                        kendo._l.showInfoNotification('Form has already been Finalized by another User');
                    } else {
                        kendo._l.showErrorNotification();
                    }
                }
                if (saveSuccess === 1) {
                    kendo._l.showSuccessNotification();
                    if (finalized) {
                        $('#mprAgendaForm').submit();
                    }
                }
            });
        });
    }
};